<div class="md-4">
  @for (item of associationsSearchKeysConfig; track $index) {
    @if (item.value | changeLogChildKey; as key) {
      @if (changeLogs?.[key]; as log) {
        @switch (key) {
          @case (AssociationKeys.tShirtSizes) {
            @if (!isEmptyObjectLog(log)) {
              <ag-shr-change-log-detail-by-type
                [keysConfig]="[item]"
                [changeLogs]="changeLogs"
                [showRemovedData]="true"
              ></ag-shr-change-log-detail-by-type>
            }
          }
          @case (AssociationKeys.dietaryConsideration) {
            @if (!isEmptyObjectLog(log)) {
              <ag-shr-change-log-detail-by-type
                [keysConfig]="[item]"
                [changeLogs]="changeLogs"
                [showRemovedData]="true"
              ></ag-shr-change-log-detail-by-type>
            }
          }
          @case (AssociationKeys.address) {
            @if (!!log) {
              <h6>Address:</h6>
              <div class="ms-3">
                <ag-shr-change-log-address-detail [log]="log"></ag-shr-change-log-address-detail>
              </div>
            }
          }
          @case (AssociationKeys.associationType) {
            @if (!!log) {
              <div
                *var="key | getLookupByName | async as activeLookup"
                [innerHTML]="{association_type: log} | changeLogsDiffHTML : associationKeysLookup : activeLookup"
              ></div>
            }
          }
          @case (AssociationKeys.flightPreference) {
            @if (!isEmptyObjectLog(log)) {
              <ag-shr-change-log-flight-preference-grid-detail
                [log]="{ log: log, oldData: oldData?.[key] }"
              ></ag-shr-change-log-flight-preference-grid-detail>
            }
          }
          @default {
            <ag-shr-change-log-detail-by-type
              [keysConfig]="[item]"
              [changeLogs]="changeLogs"
              [showRemovedData]="true"
            ></ag-shr-change-log-detail-by-type>
          }
        }
      }
    }
  }
</div>
